import { render } from "./index.vue?vue&type=template&id=d90137c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d90137c4&lang=scss&scoped=true"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90137c4"]])

export default __exports__